class Imadoki {
  constructor(){
    const floatContactBtn = document.querySelector('.js-imadoki-float-contact-btn');
    if(floatContactBtn){
      this.floatContactBtnAnimation(floatContactBtn);
    }
    const mvAnimationEl = document.querySelector('.js-imadoki-mv');
    if(mvAnimationEl){
      this.mvAnimation(mvAnimationEl)
    }
  }
  worksImageSwiper(item) {
    if (!item) return;
    if (!item.dataset.swiperInitialized) {
      new Swiper(item,{
        spaceBetween: 10,
        slidesPerView: 'auto',
        breakpoints: {
          769: {
            spaceBetween: 30,
          }
        }
      })
      item.dataset.swiperInitialized = 'true';
      item.style.opacity = 1;
    }
  }
  floatContactBtnAnimation(floatContactBtn) {
    const tl = gsap.timeline();

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: 'body',
      start: 'top top-=600',
      end: 'top top-=800',
      toggleActions: 'play none reverse none',
      onEnter: () => floatContactBtn.classList.add('is-active'),
      onLeaveBack: () => floatContactBtn.classList.remove('is-active'),
    });

    ScrollTrigger.create({
      trigger: '#contact',
      start: 'top bottom',
      end: 'top bottom-=100',
      toggleActions: 'play none reverse none',
      onEnter: () => floatContactBtn.classList.remove('is-active'),
      onLeaveBack: () => floatContactBtn.classList.add('is-active'),
    });

  }
  mvAnimation(mvAnimationEl){
    const triggerEl = document.querySelector('.js-imadoki-animation__trigger');
    gsap.fromTo(mvAnimationEl,{
      opacity: 1
    },{
      opacity: 0,
      scrollTrigger: {
        trigger: triggerEl,
        start: 'top bottom',
        end: 'top center',
        scrub: 0
      }
    })
  }
}